// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const potter = defineModel({
  id: "potter",
  batchId: "future",
  name: "Potter",
  tags: ["building","potter","low-poly","age-of-mcp","future"],
  summary: "Throws clay into pottery — jars and vessels that store many goods.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.28, 0.12), color: "#caa46a", position: [0, 0.28, -0.33] },
      { geometry: new THREE.BoxGeometry(0.12, 0.28, 0.66), color: "#caa46a", position: [-0.33, 0.28, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [-0.42, 0.3, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [0.42, 0.3, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [-0.42, 0.3, 0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [0.42, 0.3, 0.42] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.56, 0.12), color: "#caa46a", position: [0, 0.42, -0.33] },
      { geometry: new THREE.BoxGeometry(0.12, 0.56, 0.66), color: "#caa46a", position: [-0.33, 0.42, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [-0.42, 0.525, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [0.42, 0.525, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [-0.42, 0.525, 0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [0.42, 0.525, 0.42] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.6, 0.12), color: "#caa46a", position: [0, 0.44, -0.33] },
      { geometry: new THREE.BoxGeometry(0.12, 0.6, 0.66), color: "#caa46a", position: [-0.33, 0.44, 0] },
      { geometry: new THREE.BoxGeometry(0.92, 0.06, 0.532541), color: "#7a4a26", position: [0, 0.89, 0.22], rotation: [0.598419, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.92, 0.06, 0.532541), color: "#7a4a26", position: [0, 0.89, -0.22], rotation: [-0.598419, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.96, 0.07, 0.07), color: "#4a2c18", position: [0, 1.04, 0] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.2, 0.5, 10), color: "#b06848", position: [0.22, 0.39, -0.16] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.08, 8), color: "#b06848", position: [0.22, 0.68, -0.16] },
      { geometry: new THREE.BoxGeometry(0.1, 0.1, 0.06), color: "#ff7a2e", position: [0.22, 0.24, -0.01] },
      { geometry: new THREE.BoxGeometry(0.04, 0.42, 0.04), color: "#6e4a28", position: [0.06, 0.35, 0.34] },
      { geometry: new THREE.BoxGeometry(0.04, 0.42, 0.04), color: "#6e4a28", position: [-0.22, 0.35, 0.34] },
      { geometry: new THREE.BoxGeometry(0.34, 0.04, 0.3), color: "#7a4a26", position: [-0.08, 0.58, 0.32], rotation: [0.2, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.13, 0.13, 0.03, 10), color: "#6a6a6a", position: [-0.08, 0.3, 0.3] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.02, 0.16, 6), color: "#4a4a4a", position: [-0.08, 0.24, 0.3] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.04, 0.07, 8), color: "#a8693f", position: [-0.08, 0.34, 0.3] },
      { geometry: new THREE.BoxGeometry(0.04, 0.4, 0.04), color: "#6e4a28", position: [-0.28, 0.34, -0.18] },
      { geometry: new THREE.BoxGeometry(0.04, 0.4, 0.04), color: "#6e4a28", position: [-0.28, 0.34, 0.18] },
      { geometry: new THREE.BoxGeometry(0.05, 0.03, 0.42), color: "#6e4a28", position: [-0.28, 0.32, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.03, 0.42), color: "#6e4a28", position: [-0.28, 0.48, 0] },
      { geometry: new THREE.CylinderGeometry(0.045, 0.035, 0.1, 8), color: "#a8693f", position: [-0.28, 0.38, -0.15] },
      { geometry: new THREE.CylinderGeometry(0.045, 0.035, 0.1, 8), color: "#a8693f", position: [-0.28, 0.54, -0.15] },
      { geometry: new THREE.CylinderGeometry(0.045, 0.035, 0.1, 8), color: "#a8693f", position: [-0.28, 0.38, 0] },
      { geometry: new THREE.CylinderGeometry(0.045, 0.035, 0.1, 8), color: "#a8693f", position: [-0.28, 0.54, 0] },
      { geometry: new THREE.CylinderGeometry(0.045, 0.035, 0.1, 8), color: "#a8693f", position: [-0.28, 0.38, 0.15] },
      { geometry: new THREE.CylinderGeometry(0.045, 0.035, 0.1, 8), color: "#a8693f", position: [-0.28, 0.54, 0.15] },
    ] },
  ],
  animations: [],
});
